import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gy2hjqt9aj: FaireBrandEntity = {
  token: "b_gy2hjqt9aj",
  type: "brand",
  name: "UniArt",
  avatarUrl:
    "https://cdn.faire.com/fastly/c7ef76529ba3c6fcf357ac83466be2058c0e7c0e534a424fb3436f6414db877a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0ce73b262146683b167f59996a2998737fd407743a43a0a8e58498c434a8c488.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/c7ef76529ba3c6fcf357ac83466be2058c0e7c0e534a424fb3436f6414db877a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0ce73b262146683b167f59996a2998737fd407743a43a0a8e58498c434a8c488.webp",
  location: "ESP",
  minimumOrderDollars: 153,
  rating: 4.9,
  reviewCount: 108,
  isTopShop: true,
  isInsider: false,
  description:
    "UniArt: Wholesaler of minerals, silver jewelry, and crafts.  \nAt UniArt, we bring the world of minerals closer to our customers so they can purchase them with a quality guarantee.  \nWe are importers, exporters, and manufacturers of esoteric products, costume jewelry, and silver.  \nUA is a registered sterling silver brand of UniArt and, at the same time, a guarantee of quality and style.  \nWe have a wide variety of minerals wholesale and retail, gems, precious stones, semi-precious stones, druses, tumbled stones, products for gem therapy, Reiki, horoscope stones, dowsing, Chakra therapy, costume jewelry, silver jewelry, esoteric items, and strands and strings of natural stones.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:33.857Z",
    importedBy: "entity-db-cli",
  },
};
